const lessonData = {

  2: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/800_3638933_fcch7t4j1neidcnkvzb7aixszq7inph34fu77bxj_breaking-news-banner-live-tv-studio-headline-broadcast-show-vector-g.jpg', alt: 'Breaking News', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "4", current_scene: "2", previous_scene: "1",text: "Continue" },
    ],
    scene_number: "2",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [``],
    text: [
      `<p>You arrive home around 5 AM after wrapping up an on-call chaplain shift that had you going into the county hospital around midnight. You switch on the TV while making a quick breakfast before going back to bed for a few hours.</p><p>The “Breaking News” banner scrolls across the bottom of the screen, and you turn the volume up: this station, like all the others in the area, is reporting on a shooting that took place overnight in a larger city about an hour away.</p><p>There aren’t many details available yet, but the anchors describe the shooting as having taken place at a popular restaurant and nightclub frequented by the city’s immigrant community. The venue also hosts discount nights and special events on the weekend for the city’s tight-knit LGBTQ+ community.</p>
`
    ],
    title: null,
    videos: [],
    audio: [],
  },
  
  4: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/Disaster-Relief-1-768x569.jpg', alt: 'A group of Disaster Relief chaplains standing in a circle, holding hands, heads bowed in prayer.', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "8", current_scene: "4", previous_scene: "2",text: "Continue" },
    ],
    scene_number: "4",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>In addition to your work as a spiritual care manager and chaplain at the county hospital, you are a trained spiritual care volunteer who deploys with a national, non-religious disaster relief organization when needed. Your training included almost a dozen courses in disaster spiritual care, including the complex logistics of disaster response, psychological first aid, and the team-based structure of the relief organization’s response processes.</p><p>You’ve done this work for a few years but have only ever been deployed to natural disasters. The news reports make it sound like the shooting overnight involved more than one victim and you wonder if the relief organization will be asked to respond.</p><p>Just in case, you log in to the volunteer portal online and mark yourself as available to respond if requested. You watch the TV reports for a few more minutes but, as there isn’t much more information available, you go to bed to catch up on sleep after a long night at the hospital.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  
  8: {
    checkpoint: false,
    last: false,
    checkpoints: [{
      alt: null,
      answer: false,
      content_type: 5,
      data:
        ``,
      order: 0,
      question_type: 2,
      scene_number: "8",
      sidebar: false,
    }],
    images: [],
    layoutNumber: 9,
    navigation: [
      { available_scene: "9", current_scene: "8", previous_scene: "4",text: "Continue" },
    ],
    scene_number: "8",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [],
    title: null,
    videos: [],
    audio: [],
  },
  9: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/fema-center-1-p.avif', alt: 'Disaster relief center', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "9.1", current_scene: "9", previous_scene: "8",text: "Continue" },
    ],
    scene_number: "9",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>The supervisor convenes the first of two daily meetings an hour later, gathering half a dozen volunteers. The supervisor distributes a report detailing everything known about the shooting up to that point and gives the volunteers a few moments to read through the information. </p><p>Police have shared with the relief organization that 30 were killed in the shooting, with at least a dozen more injured and now in area hospitals. One responding police officer was killed and three more were injured. The assailant is also dead, although it is unclear whether by suicide or officer shooting.</p><p>A temporary mortuary facility has been established elsewhere and its location kept confidential. Families are being notified and have begun arriving at this center, with the relief organization coordinating assistance in several rooms throughout the center.</p><p>Personnel are staffing those rooms under the supervision of the FBI, which has secured the entire convention center. No one except law enforcement and approved organizations are allowed in. There is no press or other access.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  9.1: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/ClimateDesk.12.26.24.webp', alt: 'Disaster relief booths', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "9.2", current_scene: "9.1", previous_scene: "9",text: "Continue" },
    ],
    scene_number: "9.1",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>On the way to the hospital, the route takes the team within a block of the scene of the shooting. It has been taped off by law enforcement, with FBI, state, and local police vehicles still blocking traffic past the club. On a street light post near the barricades, people have already begun leaving flowers, candles with religious imagery, and handmade memorial posters.</p><p>While sitting at a red light, you notice a few tent booths set up across the intersection from where traffic has been blocked off. A well-known religious organization has set up an aid station, with bottled water, large plastic bags full of toiletries, and solid-colored containers that 
you know from previous deployments have things like underwear and socks for those who did not pack before traveling.</p><p>Behind the cases of water, you notice what looks like stacks of books. You can’t quite make out the titles, but they look to be about the size of mass-produced Bibles and books of the Christian New Testament. Volunteers at the tent are handing out packages to a few individuals walking past. They’re also loading packages into small SUVs, with drivers clustered in conversation with a map of the city spread out on a table.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  9.2: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
   
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "9.3", current_scene: "9.2", previous_scene: "9.1",text: "Continue" },
    ],
    scene_number: "9.2",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>You also notice a group of people gathered on the sidewalk a few dozen yards from the tent. They don’t seem to be making noise, but they’re holding signs. You’re too far away to make them out, but the light turns green and you soon come level with them from the street.</p><p>You can read the signs from here. They have messages urging readers to repent and to fear the pains of hell for sin. A few have slurs about LGBTQ+ people, with phrases like “God hates you” and “Not all lives matter.”</p><p>You feel a wave of anger and confusion – working in a rural county hospital, you are not used to seeing protestors in real life, much less with messages that conflict so directly with your own values. You notice a few police officers nearby, with one watching the protestors discretely and the other periodically speaking into a radio.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  9.3: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/ARENRRYYN5AOFHI4KCNBJHIWR4.avif', alt: 'Police officers standing in front of hospital entrance', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "11", current_scene: "9.3", previous_scene: "9.2",text: "Continue" },
    ],
    scene_number: "9.3",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>As the team arrives at the hospital, you notice the main entrance is discreetly guarded by police officers – although the location of survivors has been kept confidential by the responding agencies, survivors themselves or their families may have told others where they are.</p><p>You also notice an SUV in the parking lot across from the hospital – its trunk is open, and it looks like there are some of the care packages and books you saw at the tent near the site of the shooting on her way to the hospital. The driver is standing next to the SUV and talking on a cell phone.</p><p>The multidisciplinary team is checked into the hospital by security and escorted through the emergency department. You consult your information packet to refresh yourself on the details of the family you’ll meet, but realize you need to use the restroom before getting started on what could be a long series of conversations. You start following signs toward the facilities.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  11: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [],
    layoutNumber: 8,
    navigation: [
      { available_scene: "10", current_scene: "11", previous_scene: "9.3",text: "Continue" },
    ],
    scene_number: "11",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [],
    title: null,
    videos: [],
    audio: [],
  },
  10: {
    checkpoint: false,
    last: true,
    checkpoints: [],
    images: [],
    layoutNumber: 6,
    navigation: [{available_scene: "10", current_scene: "10", previous_scene: "11",text: "End Lesson" }],
    scene_number: "10",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>You’ve completed this case study lesson. You made important decisions about how to manage, affirm, and provide comfort to complicated human emotions during violent disasters. You learned about the complex systems in place to support people during disasters and the role of the chaplain in these systems. </p>`
    ],
    title: "Lesson complete",
    videos: [],
    audio: [],
  },
};

export default lessonData;